import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";

// /heart and /assistant are static HTML pages — if the SPA shell ever intercepts them, hard-redirect to the static file
const staticPageMatch = window.location.pathname.match(/^\/(heart|assistant|nexus)\/?$/);
if (staticPageMatch) {
  window.location.replace(`/${staticPageMatch[1]}.html`);
}

// MUSEUM STANDARD: the homepage is pure static HTML (#static-home). React never mounts on "/".
const isStaticHome = window.location.pathname === "/" || window.location.pathname === "/index.html";

if (!isStaticHome && !staticPageMatch) {
  const staticHome = document.getElementById("static-home");
  if (staticHome) staticHome.remove();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster position="top-center" theme="dark" />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
